import { Box, Typography, Stack, Grid } from '@mui/material'
import React from 'react'
import ContactImage from "../assets/ContactImage.webp";
import DiscussionImage from "../assets/DiscussionImage.webp";
import ProductionImage from "../assets/ProductionImage.webp";
import QuotationImage from "../assets/QuotationImage.webp";

export const OurServices = ({ onContactClick, onDicussionClick, onQuotationClick, onProductionClick }) => {
    const services = [
        { img: ContactImage, action: onContactClick, alt: "Contact" },
        { img: DiscussionImage, action: onDicussionClick, alt: "Discussion" },
        { img: QuotationImage, action: onQuotationClick, alt: "Quotation" },
        { img: ProductionImage, action: onProductionClick, alt: "Production" },
    ];

    return (
        <Box sx={{
            backgroundColor: "#7C001F",
            width: "100%",
            minHeight: "15vh",
            py: { xs: 4, md: 0 }, // Add padding on mobile
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <Grid container spacing={4} alignItems="center" justifyContent="center">
                {/* Title Section */}
                <Grid item xs={12} md={4}>
                    <Typography
                        sx={{
                            color: '#FFF',
                            fontFamily: 'Inter, sans-serif',
                            fontSize: { xs: '18px', md: '24px' }, // Responsive font size
                            fontWeight: 600,
                            textAlign: { xs: 'center', md: 'left' },
                            pl: { md: 8 }, // Padding only on desktop
                            lineHeight: 1.4
                        }}
                    >
                        OUR SERVICES AND CUSTOMIZATION PROCESS
                    </Typography>
                </Grid>

                {/* Icons Section */}
                <Grid item xs={12} md={8}>
                    <Stack
                        direction="row"
                        spacing={{ xs: 2, md: 8 }} // Responsive spacing
                        justifyContent={{ xs: 'center', md: 'flex-start' }}
                        flexWrap="wrap"
                        useFlexGap
                        sx={{ px: { xs: 2, md: 0 } }}
                    >
                        {services.map((service, index) => (
                            <Box
                                key={index}
                                component="img"
                                src={service.img}
                                alt={service.alt}
                                onClick={service.action}
                                sx={{
                                    height: { xs: '80px', md: '120px' }, // Responsive image height
                                    width: 'auto',
                                    cursor: 'pointer',
                                    transition: 'transform 0.3s ease-in-out',
                                    borderRadius: '10px',
                                    '&:hover': {
                                        transform: 'scale(1.1)'
                                    }
                                }}
                            />
                        ))}
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    )
}
